<script lang="ts" setup>
import AirlineOrderTable from "@/data-views/tables/airline_order/AirlineOrderTable.vue";
definePage({
  meta: {
    action: "read",
    subject: "AirlineOrder",
  },
});
</script>

<template>
  <VRow class="match-height">
    <VCol cols="12">
      <AirlineOrderTable />
    </VCol>
  </VRow>
</template>
